import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { ShopperMissionSocialPage } from './shopper-mission-social';

@NgModule({
  declarations: [
    ShopperMissionSocialPage,
  ],
  imports: [
    IonicPageModule.forChild(ShopperMissionSocialPage),
    TranslateModule.forChild()
  ],
})
export class ShopperMissionSocialPageModule {}



// WEBPACK FOOTER //
// ./src/pages/shopper-mission-social/shopper-mission-social.module.ts